<template>
    <Avatar class="executive" :image="avatarUri" :text="avatarText" :size="size" />
</template>
<script setup>
import Avatar from '@/components/shared/avatar'

import { computed } from 'vue'

const props = defineProps({
    executive: {
        type: Object,
        required: true,
    },
    size: {
        type: String,
        default: 'medium',
    },
})

const avatarUri = computed(() => {
    const id = props.executive.id
    return id ? `/api/avatars/executives/${id}` : null
})

const avatarText = computed(() => {
    const parts = props.executive.colloquialName.split(' ')
    return (parts[0][0] ?? '') + (parts[parts.length - 1][0] ?? '')
})
</script>
